import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'pixl-card3',
  imports: [
    MatCardModule
  ],
  templateUrl: './card3.component.html',
  styleUrl: './card3.component.scss'
})
export class Card3Component {

}
